module.exports = __webpack_public_path__ + "img/pic5.443f28da.png";